import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaRocket, FaBookOpen, FaGraduationCap, FaUsers } from "react-icons/fa";

// Import Swiper React components and required styles
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import "./ExpertServicesHeader.css";
import HighlightServicesCard from "../../common_components/highlightServicesCard/HighlightServicesCard";
import BreadcrumbNav from "../../common_components/breadcrumbNav/BreadcrumbNav";

const categoryTabsData = [
  { id: 1, title: "Highlight", icon: "/assets/Images/career_solutions/HighlightServices/boost.svg",  link:"/career-solutions"},
  { id: 2, title: "Prep", icon: "/assets/Images/career_solutions/HighlightServices/prep.svg", link:"/service-prep"  },
  { id: 3, title: "Learn", icon: "/assets/Images/career_solutions/HighlightServices/learn.svg" , link:"https://profcyma.com/"},
  { id: 4, title: "Network", icon: "/assets/Images/career_solutions/HighlightServices/network.svg" , link:"/service-network"},
];

const breadcrumbPaths = [
  { label: "Home", url: "/" },
  { label: "Services", url: "/career-services" },
];

const ExpertServicesHeader = () => {
  return (
    <div className="expert-services-header-parent">
      <Container className="py-4">

        <BreadcrumbNav items={breadcrumbPaths} />
        <Row className="align-items-center g-4">
          
          {/* Left Text Column */}
          <Col lg={5} md={12}>
            <div className="content-left-block">
              <h1 className="main-title">Explore Our Expert Career Services</h1>
              <p className="description-text">
                Stand out from other jobseekers! Enhance your profile with
                industry-standard guidance. Choose from our tailored career
                services to revolutionise your job search.
              </p>
              <div className="trust-badge">
                Trusted by <span className="purple-count">75M</span> users across Asia &amp; the Gulf
              </div>
            </div>
          </Col>

          {/* Right Column with Swiper Slider */}
          <Col lg={7} md={12}>
            <div className="swiper-container-wrapper">
              <Swiper
                spaceBetween={20}
                slidesPerView={2}
                breakpoints={{
                  // Responsive grid view matching desktop layouts
                  576: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 4,
                  }
                }}
                className="category-swiper"
              >
                {categoryTabsData.map((category) => (
                  <SwiperSlide key={category.id} className="d-flex justify-content-center py-2">
                    <HighlightServicesCard title={category.title} icon={category.icon} link={category.link} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>

        </Row>
      </Container>
    </div>
  );
};

export default ExpertServicesHeader;